<div class=" container">
  <div class="text-center ">
    <h2 class="heading">Personal Information</h2>
    <h2>व्यक्तिगत जानकारी</h2>
  </div>
<!--  <prettyjson [obj]="studentForm.value"></prettyjson>-->

  <section class="row">
    <div *ngIf="mData==undefined" class="row">
<!--      -->
<!--      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">-->
<!--        <mat-label>Centre Name</mat-label>-->
<!--        <mat-select [formControl]="centreControl" (selectionChange)="onCentreSelected($event)">-->
<!--          <mat-option *ngFor="let c of centres$|async" [value]="c">{{ c.centreName }}</mat-option>-->
<!--        </mat-select>-->
<!--      </mat-form-field>-->

      <app-searchable-select class="col-md-4"
                             [options]="centres$ | async"
                             [selectedValue]="selectedCentre"
                             [displayWithFn]="displayCentre"
                             [placeholder]="'Select Centre'"
                             [label]="'Select Centre'"
                             (selectionChange)="onCentreSelect($event)"
      ></app-searchable-select>


<!--      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">-->
<!--        <mat-label>Select Child</mat-label>-->
<!--        <mat-select (selectionChange)="onChildSelect($event)">-->
<!--          <mat-option *ngFor="let c of mChildren" [value]="c">{{ c.firstName }} {{ c.lastName }}</mat-option>-->
<!--        </mat-select>-->
<!--      </mat-form-field>-->

      <div class="col-md-4 col-sm-12 d-flex align-items-start">
        <mat-form-field appearance="outline" class="flex-grow-1">
          <mat-label>Search by Child Code</mat-label>
          <input
            matInput
            placeholder="Example: AL-2026-000000"
            [formControl]="childCodeSearchControl"
            autocomplete="off"
            (keydown.enter)="onSearchByChildCode()"
          />
        </mat-form-field>
        <button mat-icon-button color="primary" class="ml-2" type="button"
                matTooltip="Search Child" (click)="onSearchByChildCode()">
          <mat-icon>search</mat-icon>
        </button>
      </div>

      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Select Child</mat-label>

        <mat-select
          [formControl]="childSelectControl"
          (selectionChange)="onChildSelect($event)"
          (opened)="onChildDropdownOpen()"
        >

          <mat-option class="no-select-option" (click)="$event.stopPropagation()">
            <div class="mat-select-search">
              <input
                matInput
                placeholder="Search child..."
                [formControl]="childSearchControl"
                autocomplete="off"
                (keydown)="$event.stopPropagation()"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                (focus)="$event.stopPropagation()"
              />
            </div>
          </mat-option>

          <!-- FIX APPLIED HERE -->
          <mat-option *ngFor="let c of filteredChildren" [value]="c">
            {{ c.firstName }} {{ c.lastName }}
          </mat-option>

        </mat-select>

        <mat-error *ngIf="childSelectControl?.errors?.required">
          Required
        </mat-error>
      </mat-form-field>



    </div>
    <div class="text-center m-1" *ngIf="mData!=null">
      <h2><strong>{{ mData.studentName }}</strong></h2>
      <h3>{{ mData.centreName }}</h3>
    </div>
    <!--<prettyjson [obj]="dischargeAssessment"></prettyjson>-->
    <div *ngIf="!isView" class="row">
      <div class="col-md-4"></div>
      <div class="col-md-4">
        <div class="m-4" *ngIf="selectedChild!=null">
          <ng-container *ngIf="dischargeSessionDetails">
            <!--            <prettyjson [obj]="dischargeSessionDetails"></prettyjson>-->
          </ng-container>
          <table class="table table-bordered">
            <tr>
              <th>Guardian 1 Name</th>
              <td>{{ mGuardian1Name }}</td>
            </tr>

            <tr>
              <th>Guardian 1 Occupation</th>
              <td>{{ mGuardian1Occupation }}</td>
            </tr>
            <tr>
              <th>Guardian 2 Name</th>
              <td>{{ mGuardian2Name }}</td>
            </tr>
            <tr>
              <th>Guardian 2 Occupation</th>
              <td>{{ mGuardian2Occupation }}</td>
            </tr>
          </table>

        </div>

      </div>
      <div class="col-md-4"></div>

    </div>

  </section>


  <form [formGroup]="studentForm">
    <div class="row" *ngIf="!isView">

      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Student Name / छात्र का नाम</mat-label>
        <input matInput (blur)="onBlur('studentName')" placeholder="Example: राम कुमार" required
               formControlName="studentName">

      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Date of Birth / जन्म तिथि</mat-label>
        <input matInput [matDatepicker]="dobPicker" formControlName="dateOfBirth">
        <mat-hint>dd/MM/yyyy</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
        <mat-datepicker #dobPicker></mat-datepicker>

      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Father's Name / पिता का नाम</mat-label>
        <input matInput (blur)="onBlur('fatherName')" placeholder="Example: महेश शर्मा" required
               formControlName="fatherName">

      </mat-form-field>

      <mat-form-field style="display: none;" appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Father's Occupation / पिता का पेशा</mat-label>
        <input matInput (blur)="onBlur('fatherOccupation')" placeholder="Example: Teacher" required
               formControlName="fatherOccupation">

      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Mother's Name / माँ का नाम</mat-label>
        <input matInput (blur)="onBlur('motherName')" placeholder="Example: सुषमा शर्मा" required
               formControlName="motherName">
      </mat-form-field>

      <mat-form-field style="display: none;" appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Mother's Occupation / माँ का पेशा</mat-label>
        <input matInput (blur)="onBlur('motherOccupation')" placeholder="Example: School Teacher" required
               formControlName="motherOccupation">
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Mother Tongue / मातृभाषा</mat-label>
        <input matInput (blur)="onBlur('motherTongue')" placeholder="Example: Hindi" required
               formControlName="motherTongue">
      </mat-form-field>


      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Medium of Instruction / पाठ्यध्यान का माध्यम</mat-label>
        <input matInput (blur)="onBlur('mediumOfInstruction')" placeholder="Example: Hindi or English" required
               formControlName="mediumOfInstruction">
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Permanent Address / स्थायी पता</mat-label>
        <input matInput (blur)="onBlur('address');onBlur('city');onBlur('state');onBlur('pincode')"
               placeholder="Example: Street Address, City" required
               formControlName="address">
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Contact Details / संपर्क विवरण</mat-label>
        <input matInput (blur)="onBlur('contactDetails')" placeholder="Example: 9422919898"
               formControlName="contactDetails">
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Email Address / संपर्क पता</mat-label>
        <input matInput (blur)="onBlur('email')" placeholder="Example: xyz@gmail.com"
               formControlName="email">
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label> Date</mat-label>
        <input matInput [matDatepicker]="mDatePicker" formControlName="date">
        <mat-hint>dd/MM/yyyy</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="mDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #mDatePicker></mat-datepicker>

      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Admission Date / प्रवेश तिथि</mat-label>
        <input matInput [matDatepicker]="mAdmissionDatePicker" formControlName="admissionDate">
        <mat-hint>dd/MM/yyyy</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="mAdmissionDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #mAdmissionDatePicker></mat-datepicker>

      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Discharge Date / निष्कासन तिथि</mat-label>
        <input matInput [matDatepicker]="mDischargeDatePicker" formControlName="dischargeDate">
        <mat-hint>dd/MM/yyyy</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="mDischargeDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #mDischargeDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Grade</mat-label>
        <input matInput maxlength="1" placeholder="Example: A,B,C" required formControlName="grade">
      </mat-form-field>


      <!--        <mat-form-field appearance="outline" class="col-md-4 col-sm-12">-->
      <!--            <mat-label>Doctor's Recommendation / डॉक्टर की सिफारिश</mat-label>-->
      <!--            <input matInput (blur)="onBlur('doctorsRecommendation')" placeholder="Type the doctor's recommendation here"-->
      <!--                   required formControlName="doctorsRecommendation">-->
      <!--        </mat-form-field>-->

      <hr>
      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Language Sessions</mat-label>
        <input matInput required formControlName="languageSessions">
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Maths Sessions</mat-label>
        <input matInput required formControlName="mathSessions">
      </mat-form-field>


      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>EVS Sessions</mat-label>
        <input matInput required formControlName="evsgkSessions">
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-3 col-sm-12">
        <mat-label>Language Topics Covered</mat-label>
<!--        <mat-select formControlName="languageTopicsCovered">-->
<!--          <mat-option>Select Language Topics Covered</mat-option>-->
<!--          <mat-option *ngFor="let l of LanguageList$ | async" [value]="l">{{ l }}</mat-option>-->
<!--        </mat-select>-->

        <mat-select formControlName="languageTopicsCovered" (opened)="filteredLanguageList = filteredLanguageList">

<!--          <mat-option class="no-select-option" (click)="$event.stopPropagation()">-->
<!--            <input matInput placeholder="Search..." [formControl]="languageSearchControl" autocomplete="off" />-->
<!--          </mat-option>-->

          <mat-option class="no-select-option" (click)="$event.stopPropagation()">
            <div class="mat-select-search">
              <input
                matInput
                placeholder="Search Topic..."
                [formControl]="languageSearchControl"
                autocomplete="off"
                (keydown)="$event.stopPropagation()"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                (focus)="$event.stopPropagation()"
              />
            </div>
          </mat-option>

          <mat-option *ngFor="let l of filteredLanguageList" [value]="l">{{ l }}</mat-option>

        </mat-select>

      </mat-form-field>


      <!-- Suffix Icon Button -->
    <div class="col-md-1 col-sm-12">
      <button mat-icon-button matSuffix aria-label="Add Language Topics Covered" matTooltip="Add Language Topics Covered" (click)="onAddLanguageTopic('Report Card Lgn Topic')">
        <mat-icon>add</mat-icon>
      </button>
    </div>

      <mat-form-field appearance="outline" class="col-md-3 col-sm-12">
        <mat-label>Maths Topics Covered</mat-label>
<!--        <mat-select formControlName="mathsTopicsCovered">-->
<!--          <mat-option>Select Maths Topics Covered</mat-option>-->
<!--          <mat-option *ngFor="let l of MathTopicList$ | async" [value]="l">{{ l }}</mat-option>-->
<!--        </mat-select>-->

        <mat-select formControlName="mathsTopicsCovered" (opened)="filteredMathList = filteredMathList">

<!--          <mat-option class="no-select-option" (click)="$event.stopPropagation()">-->
<!--            <input matInput placeholder="Search..." [formControl]="mathSearchControl" autocomplete="off" />-->
<!--          </mat-option>-->

          <mat-option class="no-select-option" (click)="$event.stopPropagation()">
            <div class="mat-select-search">
              <input
                matInput
                placeholder="Search Topic..."
                [formControl]="mathSearchControl"
                autocomplete="off"
                (keydown)="$event.stopPropagation()"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                (focus)="$event.stopPropagation()"
              />
            </div>
          </mat-option>

          <mat-option *ngFor="let l of filteredMathList" [value]="l">{{ l }}</mat-option>

        </mat-select>

      </mat-form-field>


      <!-- Suffix Icon Button -->
      <div class="col-md-1 col-sm-12">
        <button mat-icon-button matSuffix aria-label="Add Maths Topics Covered" matTooltip="Add Maths Topics Covered" (click)="onAddLanguageTopic('Report Card Math Topic')">
          <mat-icon>add</mat-icon>
        </button>
      </div>
      <mat-form-field appearance="outline" class="col-md-3 col-sm-12">
        <mat-label>EVS GK Topics Covered</mat-label>
<!--        <input matInput required formControlName="evsgkTopicsCovered">-->
<!--        <mat-select formControlName="evsgkTopicsCovered">-->
<!--          <mat-option>Select EVS GK Topics Covered</mat-option>-->
<!--          <mat-option *ngFor="let l of EvsGKList$ | async" [value]="l">{{ l }}</mat-option>-->
<!--        </mat-select>-->

        <mat-select formControlName="evsgkTopicsCovered" (opened)="filteredEvsList = filteredEvsList">

<!--          <mat-option class="no-select-option" (click)="$event.stopPropagation()">-->
<!--            <input matInput placeholder="Search..." [formControl]="evsSearchControl" autocomplete="off" />-->
<!--          </mat-option>-->

          <mat-option class="no-select-option" (click)="$event.stopPropagation()">
            <div class="mat-select-search">
              <input
                matInput
                placeholder="Search Topic..."
                [formControl]="evsSearchControl"
                autocomplete="off"
                (keydown)="$event.stopPropagation()"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                (focus)="$event.stopPropagation()"
              />
            </div>
          </mat-option>


          <mat-option *ngFor="let l of filteredEvsList" [value]="l">{{ l }}</mat-option>

        </mat-select>

      </mat-form-field>
      <!-- Suffix Icon Button -->
      <div class="col-md-1 col-sm-12">
        <button mat-icon-button matSuffix aria-label="Add EVS GK Topics Covered" matTooltip="Add EVS GK Topics Covered" (click)="onAddLanguageTopic('Report Card Evs GK Topic')">
          <mat-icon>add</mat-icon>
        </button>
      </div>
      <mat-form-field appearance="outline" class="col-md-3 col-sm-12">
        <mat-label>Events</mat-label>
<!--        <mat-select formControlName="events">-->
<!--          <mat-option>Select Events</mat-option>-->
<!--          <mat-option *ngFor="let l of EventsList$ | async" [value]="l">{{ l }}</mat-option>-->
<!--        </mat-select>-->

        <mat-select formControlName="events" (opened)="filteredEventsList = filteredEventsList">

<!--          <mat-option class="no-select-option" (click)="$event.stopPropagation()">-->
<!--            <input matInput placeholder="Search..." [formControl]="eventsSearchControl" autocomplete="off" />-->
<!--          </mat-option>-->

          <mat-option class="no-select-option" (click)="$event.stopPropagation()">
            <div class="mat-select-search">
              <input
                matInput
                placeholder="Search child..."
                [formControl]="eventsSearchControl"
                autocomplete="off"
                (keydown)="$event.stopPropagation()"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                (focus)="$event.stopPropagation()"
              />
            </div>
          </mat-option>

          <mat-option *ngFor="let l of filteredEventsList" [value]="l">{{ l }}</mat-option>

        </mat-select>

      </mat-form-field>
      <!-- Suffix Icon Button -->
      <div class="col-md-1 col-sm-12">
        <button mat-icon-button matSuffix aria-label="Add Events" matTooltip="Add Repost Card Events" (click)="onAddLanguageTopic('Report Card Events')">
          <mat-icon>add</mat-icon>
        </button>
      </div>
      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Participation</mat-label>
        <input matInput formControlName="contributions">
      </mat-form-field>
      <!--      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">-->
      <!--        <mat-label>Language Remarks</mat-label>-->
      <!--        <input matInput required formControlName="languageRemarks">-->
      <!--      </mat-form-field>-->
      <!--      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">-->
      <!--        <mat-label>Maths Remarks</mat-label>-->
      <!--        <input matInput required formControlName="mathsRemarks">-->
      <!--      </mat-form-field>-->
      <!--      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">-->
      <!--        <mat-label>EVS/GK Remarks</mat-label>-->
      <!--        <input matInput required formControlName="evsgkRemarks">-->
      <!--      </mat-form-field>-->
      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>General Remarks / सामान्य टिप्पणियाँ</mat-label>
        <input matInput (blur)="onBlur('generalRemarks')" placeholder="Type your remarks here" required
               formControlName="generalRemarks">
      </mat-form-field>


      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>Languange Grade</mat-label>
        <mat-select formControlName="mLanguageGrade1">
          <mat-option value="A">A</mat-option>
          <mat-option value="B">B</mat-option>
          <mat-option value="C">C</mat-option>
          <mat-option value="D">D</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label> Mathmatics Grade</mat-label>
        <mat-select formControlName="mMathematics">
          <mat-option value="A">A</mat-option>
          <mat-option value="B">B</mat-option>
          <mat-option value="C">C</mat-option>
          <mat-option value="D">D</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
        <mat-label>EVS/GK Grade</mat-label>
        <mat-select formControlName="mEvsGkGrade1">
          <mat-option value="A">A</mat-option>
          <mat-option value="B">B</mat-option>
          <mat-option value="C">C</mat-option>
          <mat-option value="D">D</mat-option>
        </mat-select>
      </mat-form-field>

<!--      <mat-form-field appearance="outline" class="col-md-4">-->
<!--        <mat-label>Teacher</mat-label>-->
<!--        <mat-select formControlName="teacher" [compareWith]="compareWith" (selectionChange)="changeTeacher($event)">-->
<!--          <mat-option *ngFor="let t of teachers" [value]="t">{{ t.name }}</mat-option>-->
<!--        </mat-select>-->
<!--      </mat-form-field>-->

      <mat-form-field appearance="outline" class="col-md-4">
        <mat-label>Teacher</mat-label>

        <mat-select
          formControlName="teacher"
          [compareWith]="compareWith"
          (selectionChange)="changeTeacher($event)"
          (opened)="filteredTeachers = filteredTeachers"
        >

          <!-- SEARCH BOX -->
          <mat-option class="no-select-option" (click)="$event.stopPropagation()">
            <div class="mat-select-search">
              <input
                matInput
                placeholder="Search teacher..."
                [formControl]="teacherSearchControl"
                autocomplete="off"
                (keydown)="$event.stopPropagation()"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                (focus)="$event.stopPropagation()"
              />
            </div>
          </mat-option>

          <!-- FILTERED TEACHERS -->
          <mat-option *ngFor="let t of filteredTeachers" [value]="t">
<!--            {{ t.name }} — {{ t.designation }}-->
            {{t.name}}
          </mat-option>

        </mat-select>
      </mat-form-field>


    </div>
    <div class="d-flex justify-content-center">
      <button *ngIf="!isView" mat-raised-button color="accent" class="m-2" type="submit" (click)="onSubmit()">
        Submit / प्रस्तुत करें
      </button>
      <button *ngIf="isView||isEdit" mat-raised-button color="accent" class="m-2" (click)="printFront()">
        Print / प्रिंट करें
      </button>
    </div>

  </form>


  <!--REPORT CARD-->
  <div class="row p-2" #front>
    <!*--------------------------------------------- PAGE1 --------------------------------------------->
    <div class="col-md-6 pr-4" style="height: 710px;">
      <div class="col-md-12 acknowledgement" style="border: 1px solid #0c0c0c;height: 700px;">
        <h2><Strong>स्वीकृति</Strong></h2>
        <p>इससे साक्षात्कार किया जाता है कि <span>{{ mStudentName }} </span> ने गणित, पर्यावरण विज्ञान, सामान्य ज्ञान,
          और
          भाषा
          की पूर्वापेक्षा ज्ञान पूरा किया है: <span>{{ mDate|date:'dd/MM/yyyy' }}</span> पर।</p>

        <p>उसने <span>{{ mGrade }}</span> ग्रेजुएशन के साथ कोर्स पूरा किया है।</p>

        <p>हम छात्र के द्वारा कैंसर से पुनर्ग्रहण के दौरान धैर्य और साहस की प्रशंसा करते हैं।</p>

        <p>हम बच्चे द्वारा कैंसर के इलाज और लड़ाई के दौरान दिखाए गए साहस की प्रशंसा करते हैं। हम उसके भविष्य के लिए उसे
          सभी
          शुभकामनाएं देते हैं।</p>


        <h2><Strong>Acknowledgement</Strong></h2>
        <p>This is to acknowledge that <span>{{ mStudentName }}</span> successfully completed prerequisite knowledge of
          subjects: Mathematics, Environmental Science, General Knowledge, and Language on
          <span>{{ mDate|date:'dd/MM/yyyy' }}</span>.</p>

        <p>He/she has completed the course with a <span>{{ mGrade }}</span> gradation. <br>

          We also commend the persistence and mettle held by the pupil during his/her recuperation from Cancer.
          <br>
          We admire the courage shown by the child during his/her treatment and battle against Cancer. We wish him/her
          all
          the best for his/her future.</p>

        <table style="width: 100%; border-collapse: collapse;">
          <tr>
            <td style="width: 33%; padding: 5px; vertical-align: top;text-align: center;">
              <p><span>शिक्षक इंचार्ज </span> <br> (Teacher In-charge)</p>
              <ng-container *ngIf="teacherSelected">
                <img class="stamp" [src]="teacherSelected.sign" alt="">
                <br><span>{{ teacherSelected.name }}</span>
                <br><span>{{ teacherSelected.designation }}</span>
              </ng-container>
            </td>
            <td style="width: 33%; padding: 5px; vertical-align: top;  text-align: center;">
              <p><span>प्राधिकरण के हस्ताक्षर </span><br> (Signature of Authority)</p>
              <ng-container>
                <img class="stamp" [src]="dwaniSign" alt="">
                <br><span>Dwani Gujral</span>
                <br><span>Lead Teacher</span>
              </ng-container>
            </td>
            <td style="width: 33%; padding: 5px; vertical-align: top;  text-align: center;">
              <div>मोहर (Stamp)</div>
              <ng-container *ngIf="stamp">
                <img src="assets/images/alseal.jpg" class="stamp" alt="">
              </ng-container>
            </td>
          </tr>
        </table>
      </div>
      <br>
    </div>
    <!*--------------------------------------------- PAGE2 --------------------------------------------->
    <div class="col-md-6 pl-4" style="height: 710px;">
      <div class="col-md-12 acknowledgement" style="border: 1px solid #0c0c0c;height: 700px;">
        <div class="text-center ">

          <div class="row">
            <div class="col-md-3 my-auto">
              <img src="assets/logo.png" alt="logo" class="img-fluid">
            </div>
            <div class="col-md-9 my-auto">
              <div style="font-size:20px">ACCESS LIFE ASSISTANCE FOUNDATION</div>
              <div style="font-size:20px">एक्सेस लाइफ असिस्टेस फाउंडेशन</div>
            </div>
          </div>
          <div class="address">
            <p>बंगला नंबर 6, जॉली लैंड सीएचएस, घाटा विलेज रोड, चेंबूर, मुंबई: महाराष्ट्र 400071</p>
            <p> Bungalow No 6. Jolly Land CHS. Ghatta Village Rd. Chembur, Mumbai: Maharashtra 400071</p>
            <!--            <p>Mumbai Pune Manipal Chandigarh</p>-->
            <h3 class="text-center fw-bold">{{ mSelectedCentreName }} </h3>

          </div>
          <div class="contact">
            <p>Contact Number: +91-0880222377</p>
          </div>
          <div class="email">
            <p>Email ID: contact@accesslife.org</p>
          </div>
          <div class="website">
            <p>Website: <a href="www.accesslife.org">www.accesslife.org</a></p>
          </div>

          <div class="textcenter">परिणाम पत्र</div>
          <div class="textcenter">( Report Card )</div>
        </div>
        <div class="d-flex justify-content-center">
          <div class="pic">
            <!--            <img *ngIf="(childDocuments && childDocuments.length > 0) || (this.studentForm.controls.image.value!='' && this.studentForm.controls.image.value!=null)"-->
            <!--                 [src]="getChildPhotoUrl(childDocuments)"-->
            <!--                 class="pic" alt="">-->

            <!--            <ng-container >-->
            <!--              &lt;!&ndash; Add an input element for manual picture upload &ndash;&gt;-->
            <!--              <input type="file" (change)="onFileChange($event)" accept="image/*" *ngIf="!isPrinting">-->
            <!--              &lt;!&ndash; Display a preview of the uploaded picture &ndash;&gt;-->
            <!--              <img *ngIf="uploadedPicture" [src]="uploadedPicture" class="pic" alt="">-->
            <!--              <img *ngIf="this.mData?.image" [src]="this.mData?.image" class="pic" alt="">-->
            <!--            </ng-container>-->
            <ng-container *ngIf="!isView">
              <input type="file" (change)="onFileChange($event)" accept="image/*" *ngIf="!isPrinting">
              <img *ngIf="uploadedPicture" [src]="uploadedPicture" class="pic" alt="Uploaded">
              <img *ngIf="!uploadedPicture && mData?.image" [src]="mData?.image" class="pic" alt="Original">
            </ng-container>
            <ng-container *ngIf="isView">
              <img *ngIf="mData?.image" [src]="mData?.image" class="pic" alt="Original">
            </ng-container>

          </div>
        </div>
        <br>
        <div class="text-center mt-4">
          <p><strong>नाम (Name) : {{ studentForm.controls?.studentName?.value }} </strong></p>

        </div>

      </div>
    </div>
    <br>
    <br>
    <!*--------------------------------------------- PAGE3 --------------------------------------------->

    <div class="col-md-6 pr-4" style="height: 710px;">
      <div class="col-md-12 acknowledgement" style="border: 1px solid #0c0c0c;height: 700px;">
        <h3 class="text-center"><Strong>Personal Information</Strong></h3>
        <h3 class="text-center"><Strong>व्यक्तिगत जानकारी</Strong></h3>
        <table style="width: 100%; border-collapse: collapse;">
          <tr>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">छात्र की जानकारी (Name of
              Student):
            </td>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">
              <span>{{ mStudentName }}</span></td>
          </tr>
          <tr>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">जन्म की तारीख़ (Date of
              Birth):
            </td>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">
              <span>{{ mDateOfBirth | date:'dd/MM/yyyy' }}</span></td>
          </tr>
          <tr>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">पिता का नाम (Father's
              Name):
            </td>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">
              <span>{{ mFatherName }}</span></td>
          </tr>
          <tr style="display: none;">
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">व्यवसाय (Occupation):
            </td>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">
              <span>{{ mFatherOccupation }}</span></td>
          </tr>
          <tr>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">माता का नाम (Mother's
              Name):
            </td>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">
              <span>{{ mMotherName }}</span></td>
          </tr>
          <tr style="display: none;">
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">व्यवसाय (Occupation):
            </td>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">
              <span>{{ mMotherOccupation }}</span></td>
          </tr>
          <tr>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">मातृभाषा (Mother's
              Tongue):
            </td>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">
              <span>{{ mMotherTounge }}</span></td>
          </tr>
          <tr>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">शिक्षा का माध्यम (Medium
              of Instruction):
            </td>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">
              <span>{{ mMediumOfInstruction }}</span></td>
          </tr>
          <tr>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000; ">स्थायी पत्ता (Permanent
              Address):
            </td>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">
              <span>{{ mAddress }}</span></td>
          </tr>
          <tr>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">संपर्क (Mobile Number):
            </td>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">
              <span>{{ mContactDetails2 }}</span></td>
          </tr>
          <tr>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">इ मेल (Email):</td>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;"><span>{{ mEmail }}</span>
            </td>
          </tr>
          <tr>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">प्रवेश (Admission
              Date):
            </td>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">
              <span>{{ mAdmissionDate | date:'dd/MM/yyyy' }}</span></td>
          </tr>
          <tr>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">अवतारण (Discharge
              Date):
            </td>
            <td style="width: 50%; padding: 8px; vertical-align: top; border: 1px solid #000;">
              <span>{{ mDischargeDate | date:'dd/MM/yyyy' }}</span></td>
          </tr>
        </table>
      </div>
    </div>
    <!-- PAGE4 content here -->
    <div class="col-md-6 pl-4" style="height: 710px;">
      <div class="col-md-12 acknowledgement" style="border: 1px solid #0c0c0c;height: 700px;">
        <div class="text-center"><strong>शैक्षणिक विवरण</strong></div>
        <div class="text-center"><strong>Academic Information</strong></div>
        <div class="row">
          <table style="padding-left: 50px; padding-right: 50px; width: 100%; table-layout: fixed;">

            <colgroup>
              <col style="width: 8%">   <!-- Sr. No. -->
              <col style="width: 15%">  <!-- Subject -->
              <col style="width: 12%">   <!-- No. Of Sessions -->
              <col style="width: 32%">  <!-- Topics Covered (WIDER) -->
              <col style="width: 12%">   <!-- Grade -->
              <col style="width: 21%">  <!-- Performance -->
            </colgroup>
            <thead>
            <tr>
              <th style="border: 1px solid #000; text-align: center; padding: 2px; background-color: #f2f2f2;">क्रं<br>Sr.
                No.
              </th>
              <th style="border: 1px solid #000; text-align: center; padding: 2px; background-color: #f2f2f2;">विषय<br>(Subject)
              </th>
              <th style="border: 1px solid #000; text-align: center; padding: 2px; background-color: #f2f2f2;">कुल
                सत्र<br>(No. Of Sessions)
              </th>
              <th style="border: 1px solid #000; text-align: center; padding: 2px; background-color: #f2f2f2;">अध्याय
                पूर्ण<br>(Topics Covered)
              </th>
              <th style="border: 1px solid #000; text-align: center; padding: 2px; background-color: #f2f2f2;">
                ग्रेडेशन<br>(GRADE)
              </th>
              <th style="border: 1px solid #000; text-align: center; padding: 2px; background-color: #f2f2f2;">प्रदर्शन
                <br>(Performance)
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td style="border: 1px solid #000; text-align: center; padding: 2px;">1</td>
              <td style="border: 1px solid #000; text-align: center; padding: 2px;">Language</td>
              <td style="border: 1px solid #000; text-align: center; padding: 2px;">{{ mLanguageSessions }}</td>
              <td style="border: 1px solid #000; text-align: center; padding: 2px;">{{ mLanguageTopicsCovered }}</td>
              <td style="border: 1px solid #000; text-align: center; padding: 2px;">{{ mLanguageGrade }}</td>
              <td
                style="border: 1px solid #000; text-align: center; padding: 2px;">{{ generatePerformance(mLanguageGrade) }}
              </td>
            </tr>
            <tr>
              <td style="border: 1px solid #000; text-align: center; padding: 8px;">2</td>
              <td style="border: 1px solid #000; text-align: center; padding: 8px;">Mathematics</td>
              <td style="border: 1px solid #000; text-align: center; padding: 8px;">{{ mMathsSessions }}</td>
              <td style="border: 1px solid #000; text-align: center; padding: 8px;">{{ mMathsTopicsCovered }}</td>
              <td style="border: 1px solid #000; text-align: center; padding: 8px;">{{ mMathematicsGrade }}</td>
              <td
                style="border: 1px solid #000; text-align: center; padding: 8px;">{{ generatePerformance(mMathematicsGrade) }}
              </td>
            </tr>
            <tr>
              <td style="border: 1px solid #000; text-align: center; padding: 8px;">3</td>
              <td style="border: 1px solid #000; text-align: center; padding: 8px;">EVS GK</td>
              <td style="border: 1px solid #000; text-align: center; padding: 8px;">{{ mEVSSessions }}</td>
              <td style="border: 1px solid #000; text-align: center; padding: 8px;">{{ mEvsgkTopicsCovered }}</td>
              <td style="border: 1px solid #000; text-align: center; padding: 8px;">{{ mEvsGkGrade }}</td>
              <td
                style="border: 1px solid #000; text-align: center; padding: 8px;">{{ generatePerformance(mEvsGkGrade) }}
              </td>
            </tr>
            </tbody>
          </table>
          <br>
          <div class="text-center mt-2"><strong>Extra Curricular Activities</strong></div>
          <div class="text-center"><strong>अतिरिक्त पाठ्यक्रम गतिविधियाँ</strong></div>
          <div style="padding-left: 50px;padding-right: 50px">
            <table style="width: 100%; border-collapse: collapse;">
              <thead>
              <tr>
                <th
                  style="border:  1px solid #000; text-align: center; padding: 8px; background-color: #f2f2f2; width: 50%;">
                  Events
                </th>
                <th
                  style="border:  1px solid #000; text-align: center; padding: 8px; background-color: #f2f2f2; width: 50%;">
                  Childs Participation
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td style="border: 1px solid #000; text-align: center; padding: 8px;">{{ mEvents }}</td>
                <td style="border: 1px solid #000; text-align: center; padding: 8px;">{{ mContribution }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <br>
          <div class="mt-2">
            General Remarks: <strong>{{ generalRemarks }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>
